// extracted by mini-css-extract-plugin
export const active = "Menu-module--active--ZO_8S";